$(document).ready(function(){
  $('.item_size .sub-optgroup').hide();
    $(".item_lids .sub-optgroup").hide();
    $('.item_type .selected-value').click(function(){
      $(this).parents('.item_type').find('ul').slideToggle();
      $('.item_size ul.sub-dropdown').slideUp();
      $('.item_lids ul.sub-dropdown').slideUp();
    });

   
    var val = '';
    $('.item_type li').click(function(){
      val = $(this).text();
      var img = $(this).attr('data-img');
      $('.item_type li').removeClass('select-val')
      $(this).addClass('select-val');
      $('#item__type').val(val);
      $('.item_size .selected-value span').text("Select Size");
      $('.item_lids .selected-value span').text("Select Lids");
      var size_img = $('.item_size li[disabled]').attr("data-img");
      var lids_img = $('.item_lids li[disabled]').attr("data-img");
      $('.item_size .item_type_img').css('background-image', 'url(' + size_img + ')')
      $('.item_lids .item_type_img').css('background-image', 'url(' + lids_img + ')')
      $('.item_type span').text(val)
      $('.item_type .item_type_img').css('background-image', 'url(' + img + ')')
      $(this).parent().slideUp();
      if (val == 'Recyclable Plastic Cups') {
        $(".item_size").find("ul.sub-optgroup").hide().filter("[label='Recyclable Plastic Cups']").show();
        $('.item_lids').show();
        $('.lids-quantity-field').show();
      } else if (val == 'Recyclable Paper Cups') {
        $(".item_size").find("ul.sub-optgroup").hide().filter("[label='Recyclable Paper Cups']").show();
        $('.item_lids').show();
        $('.lids-quantity-field').show();
       } else if (val == 'Compostable Paper Cups') {
        $(".item_size").find("ul.sub-optgroup").hide().filter("[label='Compostable Paper Cups']").show();
        $('.item_lids').show();
        $('.lids-quantity-field').show();
       } else if (val == 'Double Walled Cups') {
        $(".item_size").find("ul.sub-optgroup").hide().filter("[label='Double Walled Cups']").show();
        $('.item_lids').show();
        $('.lids-quantity-field').show();
       } else if (val == 'Gelato Cups, Soup and Food Containers') {
        $(".item_size").find("ul.sub-optgroup").hide().filter("[label='Gelato Cups']").show();
        $('.item_lids').show();
        $('.lids-quantity-field').show();
       } else if (val == 'Coffee Sleeves') {
        $('.item_lids').hide(); 
        $('.lids-quantity-field').hide();
        $(".item_size").find("ul.sub-optgroup").hide().filter("[label='Sleeves']").show();
       } else if (val == 'Napkins') {
        $('.item_lids').hide();
        $('.lids-quantity-field').hide();
        $(".item_size").find("ul.sub-optgroup").hide().filter("[label='Napkins']").show();
        } else if (val == 'Sandwich Bags') {
        $('.item_lids').hide();
        $('.lids-quantity-field').hide();
        $(".item_size").find("ul.sub-optgroup").hide().filter("[label='Sandwich Bags']").show();
       } else if (val == 'Coasters') {
        $('.item_lids').hide();
        $('.lids-quantity-field').hide();
        $(".item_size").find("ul.sub-optgroup").hide().filter("[label='Coasters']").show();
       }else if (val == 'Compostable Plastic Cups') {
        $(".item_size").find("ul.sub-optgroup").hide().filter("[label='Compostable Plastic Cups']").show();
        $('.item_lids').show();
        $('.lids-quantity-field').show();
      }
      var ItemName = $(this).attr('data-value');        
      var SelectedVal = $(this).text();
      if (SelectedVal == '') {
        $('.size-instruction-btn').addClass('disabel')
      } else {
        $('.size-instruction-btn').removeClass('disabel')
      }
      var Inputval = $('.selected-value').val();
      $('.selected-value').attr('data-class', Inputval);
      var InputAttr = $('.selected-value').attr('data-class');
      var Index = $(this).parents('.product-information-field').attr('data-index');
      var modalID = parseFloat(Index) + 1;
      var dataSizeImg = $(this).attr('data-size-img');
      setTimeout(function() {
        $('.selected-value').val(ItemName);
        var Inputval2 = $('.selected-value').val();        
        if(dataSizeImg == ''){
          $('.size-instruction-btn').addClass('disabel');
        }else{
          $('.size-instruction-btn').removeClass('disabel');
        }
        $('.modal-size-img').each(function() {
          var dataClass = $(this).attr('data-class');
          $(this).hide();
          if(Inputval2 == dataClass){
            $('[data-class="'+Inputval2+'"]').show();
          }
        })
      }, 500);
    });
    $('.item_size').click(function(){
      $(this).find('ul.sub-dropdown').slideToggle();
      $('.item_type ul.sub-dropdown').slideUp();
      $('.item_lids ul.sub-dropdown').slideUp();
    });
    $('.item_size li').click(function(){
      var size_value = $(this).text();
      var img = $(this).attr('data-img');
      $('.item_size li').removeClass('select-val')
      $(this).addClass('select-val');
      $('#item__size').val(size_value);
      $('.item_lids .selected-value span').text("Select Lids");
      $('.item_size .selected-value span').text(size_value)
      $('.item_size .item_type_img').css('background-image', 'url(' + img + ')');
      if (val == 'Recyclable Plastic Cups') {
        if (size_value == '9oz') {
          $(".item_lids").find("ul.sub-optgroup").hide().filter("[label='Recyclable Plastic Cups 9oz']").show();
        } else if (size_value == '10oz') {
          $(".item_lids").find("ul.sub-optgroup").hide().filter("[label='Recyclable Plastic Cups 10oz']").show();
        } else if (size_value == '12oz') {
          $(".item_lids").find("ul.sub-optgroup").hide().filter("[label='Recyclable Plastic Cups 12oz']").show();
        } else if (size_value == '16oz') {
          $(".item_lids").find("ul.sub-optgroup").hide().filter("[label='Recyclable Plastic Cups 16oz']").show();
        } else if (size_value == '20oz') {
          $(".item_lids").find("ul.sub-optgroup").hide().filter("[label='Recyclable Plastic Cups 20oz']").show();
        } else if (size_value == '24oz') {
          $(".item_lids").find("ul.sub-optgroup").hide().filter("[label='Recyclable Plastic Cups 24oz']").show();
        } else if (size_value == '32oz') {
          $(".item_lids").find("ul.sub-optgroup").hide().filter("[label='Recyclable Plastic Cups 32oz']").show();
        } else {
          $(".item_lids").find("ul.sub-optgroup").hide();
        }
      } else if (val == 'Recyclable Paper Cups') {
        if (size_value == '4oz') {
          $(".item_lids").find("ul.sub-optgroup").hide().filter("[label='Recyclable Paper Cups 4oz']").show();
        } else if (size_value == '5oz') {
          $(".item_lids").find("ul.sub-optgroup").hide().filter("[label='Recyclable Paper Cups 5oz']").show();
        } else if (size_value == '8oz') {
          $(".item_lids").find("ul.sub-optgroup").hide().filter("[label='Recyclable Paper Cups 8oz']").show();
        } else if (size_value == '10oz') {
          $(".item_lids").find("ul.sub-optgroup").hide().filter("[label='Recyclable Paper Cups 10oz']").show();
        } else if (size_value == '12oz') {
          $(".item_lids").find("ul.sub-optgroup").hide().filter("[label='Recyclable Paper Cups 12oz']").show();
        } else if (size_value == '16oz') {
          $(".item_lids").find("ul.sub-optgroup").hide().filter("[label='Recyclable Paper Cups 16oz']").show();
        } else if (size_value == '24oz') {
          $(".item_lids").find("ul.sub-optgroup").hide().filter("[label='Recyclable Paper Cups 24oz']").show();
        } else if (size_value == '20oz') {
          $(".item_lids").find("ul.sub-optgroup").hide().filter("[label='Recyclable Paper Cups 20oz']").show();
        } else {
          $(".item_lids").find("ul.sub-optgroup").hide();
        }
      } else if (val == 'Compostable Paper Cups') {
        if (size_value == '4oz') {
          $(".item_lids").find("ul.sub-optgroup").hide().filter("[label='Compostable Paper Cups 4oz']").show();
        } else if (size_value == '8oz') {
          $(".item_lids").find("ul.sub-optgroup").hide().filter("[label='Compostable Paper Cups 8oz']").show();
        } else if (size_value == '10oz') {
          $(".item_lids").find("ul.sub-optgroup").hide().filter("[label='Compostable Paper Cups 10oz']").show();
        } else if (size_value == '12oz') {
          $(".item_lids").find("ul.sub-optgroup").hide().filter("[label='Compostable Paper Cups 12oz']").show();
        } else if (size_value == '16oz') {
          $(".item_lids").find("ul.sub-optgroup").hide().filter("[label='Compostable Paper Cups 16oz']").show();
        } else if (size_value == '20oz') {
          $(".item_lids").find("ul.sub-optgroup").hide().filter("[label='Compostable Paper Cups 20oz']").show();
        } else {
          $(".item_lids").find("ul.sub-optgroup").hide();
        }
      } else if (val == 'Double Walled Cups') {
        if (size_value == '8oz') {
          $(".item_lids").find("ul.sub-optgroup").hide().filter("[label='Double Walled Cups 8oz']").show();
        } else if (size_value == '12oz') {
          $(".item_lids").find("ul.sub-optgroup").hide().filter("[label='Double Walled Cups 12oz']").show();
        } else if (size_value == '16oz') {
          $(".item_lids").find("ul.sub-optgroup").hide().filter("[label='Double Walled Cups 16oz']").show();
        } else if (size_value == '20oz') {
          $(".item_lids").find("ul.sub-optgroup").hide().filter("[label='Double Walled Cups 20oz']").show();
        } else {
          $(".item_lids").find("ul.sub-optgroup").hide();
        }
      } else if (val == 'Gelato Cups, Soup and Food Containers') {
        if (size_value == '6oz') {
          $(".item_lids").find("ul.sub-optgroup").hide().filter("[label='Gelato Cups 6oz']").show();
        } else if (size_value == '8oz') {
          $(".item_lids").find("ul.sub-optgroup").hide().filter("[label='Gelato Cups 8oz']").show();
        } else if (size_value == '12oz') {
         $(".item_lids").find("ul.sub-optgroup").hide().filter("[label='Gelato Cups 12oz']").show();
        } else if (size_value == '16oz') {
          $(".item_lids").find("ul.sub-optgroup").hide().filter("[label='Gelato Cups 16oz']").show();
        } else if (size_value == '24oz') {
          $(".item_lids").find("ul.sub-optgroup").hide().filter("[label='Gelato Cups 24oz']").show();
        } else if (size_value == '32oz') {
          $(".item_lids").find("ul.sub-optgroup").hide().filter("[label='Gelato Cups 32oz']").show();          
        } else {
          $(".item_lids").find("ul.sub-optgroup").hide();
        }
      }else if (val == 'Compostable Plastic Cups') {
        if (size_value == '12oz') {
          $(".item_lids").find("ul.sub-optgroup").hide().filter("[label='Compostable Plastic Cups 12oz']").show();
        } else if (size_value == '16oz') {
          $(".item_lids").find("ul.sub-optgroup").hide().filter("[label='Compostable Plastic Cups 16oz']").show();
        } else if (size_value == '20oz') {
          $(".item_lids").find("ul.sub-optgroup").hide().filter("[label='Compostable Plastic Cups 20oz']").show();
        } else if (size_value == '24oz') {
          $(".item_lids").find("ul.sub-optgroup").hide().filter("[label='Compostable Plastic Cups 24oz']").show();
        } else {
          $(".item_lids").find("ul.sub-optgroup").hide();
        }
      }
    });
    $('.item_lids').click(function(){
      $(this).find('ul.sub-dropdown').slideToggle();          
      $('.item_type ul.sub-dropdown').slideUp();
      $('.item_size ul.sub-dropdown').slideUp();
    });
    $(".item_lids li").click(function() {
     var size_value = $(this).text();
     var typtImage = $(this).attr('data-img');
     $('.item_lids li').removeClass('select-val');
     $('#item__lids').val(size_value);
     $(this).addClass('select-val');
     $('.item_lids .selected-value span').text(size_value)
     $('.item_lids .item_type_img').css('background-image', 'url(' + typtImage + ')');
   });
});